import {FormatDataTable} from '../formatDataTable';

export class DataTableOnLoad extends FormatDataTable {

    constructor(item, data) {

        super();

        let self = this;

        return [
            `<div class="open-modal btn btn-primary btn-sm" data-url="` + data.update_url.replace('###', item.order_id) + `" data-onload="vendorOrderModal" role="button">
               ` + item.order_id + `
            </div>`,
            item.tracking_number,
            self.shippingLogo(item),
            `<span class="order_satus" style="background:#` + item.status_color + `;">` + item.status_name + `</span>`,
            item.shipment_actual_desi,
            self.priceFormat(item.shipment_price, item.currency_name),
            self.priceFormat(item.shipment_actual_price, item.currency_name),
            self.priceFormat(item.currency_value, item.currency_name),
            self.yesNo(item.is_paid),
            this.timeAgo(item.created_at),
            item.invoice_no
        ];
    }

    priceFormat(price, currency) {
        let priceText = '-';
        if (price != null) {
            priceText = `<b>` + price + `</b> <small>TL</small>`;
        }

        return `<div class="text-center">` + priceText + `</div>`;
    }

    shippingLogo(item) {
        if (item.shipping_id != null) {
            return `
                <div class="border bg-white shipping-logo" data-toggle="tooltip"  title="` + item.shipping_variety_name + `">
                    <img src="/storage/img/shipping/` + item.shipping_id + `.webp" alt="">
                </div>
            `;
        }

        return `<div class="text-center">-</div>`;
    }
}
